(() => {
  const scope = document.querySelector('.burleywood-fd');
  if (!scope) return;

  // Scroll reveal
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  scope.querySelectorAll('.reveal').forEach(el => io.observe(el));

  // FAQ accordion
  scope.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.parentElement;
      const ans = item.querySelector('.faq-a');
      const isOpen = item.classList.contains('open');
      scope.querySelectorAll('.faq-item.open').forEach(o => {
        o.classList.remove('open');
        o.querySelector('.faq-a').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('open');
        ans.style.maxHeight = ans.scrollHeight + 'px';
      }
    });
  });

  // Expandable product images
  const triggers = Array.from(scope.querySelectorAll('[data-lightbox-trigger]'));
  const lightbox = scope.querySelector('[data-lightbox]');
  const lightboxImage = scope.querySelector('[data-lightbox-image]');
  const closeButtons = scope.querySelectorAll('[data-lightbox-close]');
  const prevButton = scope.querySelector('[data-lightbox-prev]');
  const nextButton = scope.querySelector('[data-lightbox-next]');
  let activeIndex = -1;
  let previousFocus = null;

  const showImage = (index) => {
    if (!lightbox || !lightboxImage || !triggers.length) return;
    activeIndex = (index + triggers.length) % triggers.length;
    const img = triggers[activeIndex].querySelector('img');
    if (!img) return;
    lightboxImage.src = img.currentSrc || img.src;
    lightboxImage.alt = img.alt || '';
  };

  const openLightbox = (index) => {
    if (!lightbox) return;
    previousFocus = document.activeElement;
    showImage(index);
    lightbox.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    const closeButton = scope.querySelector('.lightbox-close');
    if (closeButton) closeButton.focus({ preventScroll: true });
  };

  const closeLightbox = () => {
    if (!lightbox || lightbox.hidden) return;
    lightbox.hidden = true;
    document.documentElement.style.overflow = '';
    if (lightboxImage) lightboxImage.removeAttribute('src');
    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus({ preventScroll: true });
    }
  };

  triggers.forEach((trigger, index) => {
    trigger.addEventListener('click', () => openLightbox(index));
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', closeLightbox);
  });

  if (prevButton) {
    prevButton.addEventListener('click', () => showImage(activeIndex - 1));
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => showImage(activeIndex + 1));
  }

  document.addEventListener('keydown', (event) => {
    if (!lightbox || lightbox.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
    if (event.key === 'ArrowRight') showImage(activeIndex + 1);
  });
})();
